/**
 *
 * @param date ISO-8601 format, e.g. 2000-01-01T12:00:00+02:00
 */
export const formatDateString = (
  date?: string | undefined,
  style: "short" | "long" = "short",
  includeTime: boolean = false,
): string => {
  if (date == null) return "";
  const d = new Date(date);

  if (d.toString() === "Invalid Date") {
    throw new Error(`Could not parse date string ${date}`);
  }

  return formatDate(d, style, includeTime);
};

export const formatDate = (
  date: Date,
  style: "short" | "long" = "short",
  includeTime: boolean = false,
): string => {
  if (date.toString() === "Invalid Date") {
    throw new Error(`Date is invalid`);
  }

  const options: Intl.DateTimeFormatOptions = {
    dateStyle: style,
  };

  if (includeTime) {
    options.timeStyle = "short";
  }

  const intl = new Intl.DateTimeFormat(["nb-NO", "en-GB"], options);

  return intl.format(date).replace(",", " kl.");
};

/**
 *
 * @param date ISO-8601 format, e.g. 2000-01-01T12:00:00+02:00
 */
export const formatDateTimeString = (
  date?: string | undefined,
  style: "short" | "long" = "short",
): string => {
  if (date == null) return "";
  const d = new Date(date);

  if (d.toString() === "Invalid Date") {
    throw new Error(`Could not parse date string ${date}`);
  }

  return formatDateTime(d, style);
};

export const formatDateTime = (
  date: Date,
  style: "short" | "long" = "short",
): string => {
  if (date.toString() === "Invalid Date") {
    throw new Error(`Date is invalid`);
  }

  const intl = new Intl.DateTimeFormat(["nb-NO", "en-GB"], {
    dateStyle: style,
    timeStyle: "medium",
  });

  return intl.format(date);
};

/**
 * Returns true if date is in the past according to users browser time
 * @param date ISO-8601 format, e.g. 2000-01-01T12:00:00+02:00
 */
export const dateHasPassed = (date: string): boolean => {
  const d = new Date(date);

  if (d.toString() === "Invalid Date") {
    throw new Error(`Could not parse date string ${date}`);
  }
  const now = new Date();

  return now > d;
};

/**
 *
 * @param from ISO-8601 format, e.g. 2000-01-01T12:00:00+02:00
 * @param to ISO-8601 format, e.g. 2000-01-01T12:00:00+02:00
 * @param fromInclusive If false, subtract one day. Defaults to true
 * @param toInclusive If false, subtract one day. Defaults to false
 * @param style Defaults to "short"
 * @returns
 */
export const formatDateStringInterval = (
  from?: string | undefined,
  to?: string | undefined,
  fromInclusive: boolean = true,
  toInclusive: boolean = false,
  style: "short" | "long" = "short",
): string => {
  if (from == null || to == null) return "";

  const fromDate = new Date(from);
  const toDate = new Date(to);

  if (fromDate.toString() === "Invalid Date") {
    throw new Error(`Could not parse date string ${from}`);
  }

  if (toDate.toString() === "Invalid Date") {
    throw new Error(`Could not parse date string ${to}`);
  }

  if (fromInclusive !== true) {
    fromDate.setDate(fromDate.getDate() + 1);
  }

  if (toInclusive !== true) {
    toDate.setDate(toDate.getDate() - 1);
  }

  return `${formatDate(fromDate, style)} - ${formatDate(toDate, style)}`;
};
